import { render } from "./LocationHistory.vue?vue&type=template&id=5b79e828"
import script from "./LocationHistory.vue?vue&type=script&lang=js"
export * from "./LocationHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__